export const OrderStatus = {
  NEW: '新订单',
  UNPAID: '待支付',
  PAYING: '支付中',
  PAID: '已支付',
  CANCLED: '已取消',
  FAILED: '支付失败',
  REFUND_REVIEWING: '退款审核中',
  REFUNDING: '退款中',
  REFUNDED: '已退款',
  SERVICE_REVIEWING: '审核中',
};

export const VIPDayTypes = {
  WORKDAY: '工作日可用',
  WEEKEND: '周末可用',
  BOTH: '工作日与周末可用',
};

export const BindTypes = {
  phone: '手机号',
  alipay: '支付宝',
  wechat: '微信',
};
